var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 17,
    viewBox: "0 0 11 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.206 11.382C10.206 12.006 10.044 12.594 9.72 13.146C9.408 13.686 8.94 14.136 8.316 14.496C7.704 14.844 6.978 15.048 6.138 15.108V16.566H4.986V15.09C3.786 14.982 2.82 14.622 2.088 14.01C1.356 13.386 0.978 12.546 0.954 11.49H3.654C3.726 12.354 4.17 12.876 4.986 13.056V9.618C4.122 9.402 3.426 9.186 2.898 8.97C2.37 8.754 1.914 8.406 1.53 7.926C1.146 7.446 0.954 6.792 0.954 5.964C0.954 4.92 1.326 4.068 2.07 3.408C2.826 2.748 3.798 2.37 4.986 2.274V0.815999H6.138V2.274C7.29 2.37 8.208 2.718 8.892 3.318C9.588 3.918 9.978 4.746 10.062 5.802H7.344C7.308 5.454 7.182 5.154 6.966 4.902C6.762 4.638 6.486 4.452 6.138 4.344V7.746C7.038 7.974 7.746 8.196 8.262 8.412C8.79 8.616 9.246 8.958 9.63 9.438C10.014 9.906 10.206 10.554 10.206 11.382ZM3.582 5.838C3.582 6.234 3.702 6.558 3.942 6.81C4.182 7.05 4.53 7.248 4.986 7.404V4.29C4.554 4.35 4.212 4.512 3.96 4.776C3.708 5.04 3.582 5.394 3.582 5.838ZM6.138 13.092C6.594 13.008 6.948 12.822 7.2 12.534C7.464 12.246 7.596 11.898 7.596 11.49C7.596 11.094 7.47 10.776 7.218 10.536C6.966 10.296 6.606 10.098 6.138 9.942V13.092Z",
    fill: "#BE7637"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/$.478124e25f5502d07ae5c3f8ed116633.svg";
export { ForwardRef as ReactComponent };